import { FC, useCallback } from 'react'
import styles from 'components/features/insights/InsightPostCTALink/InsightPostCTALink.styl'
import { WithPostUid } from 'interfaces/feed'
import { useStoreSelector, useStoreDispatch } from 'helpers/reactReduxHelpers'
import { feedPostSelector } from 'selectors/feedSelectors'
import { insightCtaClickActionCreator } from 'actions/insightsActions'

type InsightPostCTALink =
  & WithPostUid

export const InsightPostCTALink: FC<InsightPostCTALink> = (props) => {
  const { children } = props
  const post = useStoreSelector((state) => feedPostSelector(state, props))
  const dispatch = useStoreDispatch()

  const sponsoredPost = post && post.type === 'sponsored_post' ? post : null
  const insight = sponsoredPost && sponsoredPost.insight || null
  const cta = insight && insight.cta && insight.cta.offer || null

  const handleClick = useCallback(() => {
    if (!cta || !insight) {
      return
    }
    dispatch(insightCtaClickActionCreator('offer', cta, insight))
  }, [cta, dispatch, insight])

  if (!cta) {
    return (
      <>
        { children }
      </>
    )
  }

  return (
    <a
      target='_blank'
      rel='noopener noreferrer'
      href={ cta.url }
      className={ styles.link }
      data-allow-propagation
      onClick={ handleClick }
    >
      { children }
    </a>
  )
}
